import React from 'react';
interface ExchangeOrderHeaderProps {
  company: {
    name: string;
    address: string[];
    phone: string;
    fax?: string;
    email: string;
    uen: string;
  };
  exchangeOrder: {
    number: string;
    supplierNo: string;
    date: string;
    soRef: string;
    staff: string;
    isDuplicate?: boolean;
  };
  supplier: {
    name: string;
    address: string[];
    attn?: string;
    tel?: string;
    fax?: string;
  };
}
export function ExchangeOrderHeader({
  company,
  exchangeOrder,
  supplier
}: ExchangeOrderHeaderProps) {
  return <>
      {/* Top Header */}
      <div className="flex justify-between items-start mb-8" data-id="element-325">
        {/* Left: Company Info */}
        <div className="flex-1" data-id="element-326">
          <div className="w-16 h-16 bg-gradient-to-br from-blue-600 to-blue-700 rounded-lg mb-4 flex items-center justify-center shadow-md" data-id="element-327">
            <span className="text-white font-bold text-xl" data-id="element-328">MT</span>
          </div>
          <h1 className="text-xl font-bold text-neutral-900 mb-2" data-id="element-329">
            {company.name}
          </h1>
          <div className="text-xs text-neutral-600 space-y-0.5 leading-relaxed" data-id="element-330">
            {company.address.map((line, i) => <p key={i} data-id="element-331">{line}</p>)}
            <p className="mt-2" data-id="element-332">Tel: {company.phone}</p>
            {company.fax && <p data-id="element-333">Fax: {company.fax}</p>}
            <p data-id="element-334">Email: {company.email}</p>
            <p data-id="element-335">UEN: {company.uen}</p>
          </div>
        </div>

        {/* Right: EO Metadata Box */}
        <div className="bg-neutral-50 border border-neutral-200 rounded-lg p-5 min-w-[300px] shadow-sm" data-id="element-336">
          <div className="space-y-2" data-id="element-337">
            <div className="flex justify-between" data-id="element-338">
              <span className="text-xs font-medium text-neutral-600" data-id="element-339">
                EO No.:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-340">
                {exchangeOrder.number}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-341">
              <span className="text-xs font-medium text-neutral-600" data-id="element-342">
                Supplier No.:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-343">
                {exchangeOrder.supplierNo}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-344">
              <span className="text-xs font-medium text-neutral-600" data-id="element-345">
                Date:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-346">
                {exchangeOrder.date}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-347">
              <span className="text-xs font-medium text-neutral-600" data-id="element-348">
                SO Ref:
              </span>
              <span className="text-xs text-neutral-900" data-id="element-349">
                {exchangeOrder.soRef}
              </span>
            </div>
            <div className="flex justify-between" data-id="element-350">
              <span className="text-xs font-medium text-neutral-600" data-id="element-351">
                Staff:
              </span>
              <span className="text-xs font-semibold text-neutral-900" data-id="element-352">
                {exchangeOrder.staff}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Centered Title with Duplicate Label */}
      <div className="flex items-center justify-center mb-6 relative" data-id="element-353">
        <h2 className="text-2xl font-bold text-neutral-900 tracking-tight" data-id="element-354">
          EXCHANGE ORDER
        </h2>
        {exchangeOrder.isDuplicate && <span className="absolute right-0 text-xs font-semibold text-red-600 border border-red-300 bg-red-50 px-2 py-1 rounded" data-id="element-355">
            DUPLICATE
          </span>}
      </div>

      {/* Supplier Block */}
      <div className="mb-6 bg-neutral-50 border border-neutral-200 rounded-lg p-5" data-id="element-356">
        <p className="text-xs font-semibold text-neutral-700 mb-3" data-id="element-357">TO:</p>
        <div className="space-y-1 mb-3" data-id="element-358">
          <p className="font-semibold text-sm text-neutral-900" data-id="element-359">
            {supplier.name}
          </p>
          <div className="text-xs text-neutral-600 space-y-0.5" data-id="element-360">
            {supplier.address.map((line, i) => <p key={i} data-id="element-361">{line}</p>)}
          </div>
        </div>
        {(supplier.attn || supplier.tel || supplier.fax) && <div className="text-xs text-neutral-600 space-y-0.5 mb-3" data-id="element-362">
            {supplier.attn && <p data-id="element-363">Attn: {supplier.attn}</p>}
            {supplier.tel && <p data-id="element-364">Tel: {supplier.tel}</p>}
            {supplier.fax && <p data-id="element-365">Fax: {supplier.fax}</p>}
          </div>}
        <div className="border-t border-neutral-200 pt-3 mt-3" data-id="element-366">
          <p className="text-xs text-neutral-700 italic" data-id="element-367">
            In exchange for this order, please issue:
          </p>
        </div>
      </div>
    </>;
}